import { useQuery } from '@tanstack/react-query';
import type { QuoteItemDTO } from '@setvi/shared/services/react-query';
import { getQuoteV2ItemsMetadataQuery } from 'Services/Query/QuotesV2';
import { transformV2ItemsToNested } from '../utils/quote-helpers';

/**
 * Fetch quote items metadata (lightweight).
 *
 * GET /v2/quote/:quoteId/items/metadata
 * Returns structural data without heavy fields (images, SKU, etc.).
 *
 * Full item enrichment for visible items is handled separately
 * by useEnrichVisibleItems, which POSTs to /v2/quote/:quoteId/items
 * with only the IDs of items currently in the viewport.
 */
export const useQuoteItems = (quoteId: string) => {
  const baseQuery = getQuoteV2ItemsMetadataQuery(quoteId);

  return useQuery<QuoteItemDTO[]>({
    queryKey: baseQuery.queryKey,
    queryFn: async () => {
      const raw = await baseQuery.queryFn();
      return transformV2ItemsToNested(raw);
    },
    enabled: !!quoteId
  });
};
